















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { JsonServiceClient, toFormData } from '@servicestack/client';
import { Validations } from 'vuelidate-property-decorators';
import { required, requiredIf } from 'vuelidate/lib/validators';
import MaskedInput from 'vue-masked-input';
import Navigator from '../Study/Navigator.vue';
import { bus, store, client, getUserInfo } from '../../shared';
import { AddStudyMiscDoc, DeleteStudyMiscDoc } from '../../shared/study';
import { UserInfo } from '../../shared/user';
import _ from 'lodash';
import { StudyMiscDoc } from '../../shared/study';

@Component({
    components: {
        /*Dropzone,*/
    },
})
export default class DocumentUpload extends Vue {
    $v: any;
    file: any = [];
    asyncState: null;
    hasSupportingDocuments: boolean = false;
    letterAgreementFile: any = null;
    bioSketchFile: any = null;

    letterAgreementSelected: boolean = false;
    letterAgreementUploaded: boolean = false;

    bioSketchSelected: boolean = false;
    bioSketchUploaded: boolean = false;
    form: any = {};
    @Validations()
    validations: any = {
        form: {},
    };

    @Watch('userInfo.study.form', { deep: true })
    public formUpdated(newValue: any, oldValue: any) {
        setTimeout(() => {
            if (newValue !== oldValue) {
                // Study Interest
                if (this.userInfo.study.form.culturedIslets !== null) {
                    this.form.culturedIslets = this.userInfo.study.form.culturedIslets;
                }
                if (this.userInfo.study.form.frozenIslets !== null) {
                    this.form.frozenIslets = this.userInfo.study.form.frozenIslets;
                }
                if (this.userInfo.study.form.acinar !== null) {
                    this.form.acinar = this.userInfo.study.form.acinar;
                }
                if (this.userInfo.study.form.histoSlides !== null) {
                    this.form.histoSlides = this.userInfo.study.form.histoSlides;
                }
                if (this.userInfo.study.form.bloodProd !== null) {
                    this.form.bloodProd = this.userInfo.study.form.bloodProd;
                }
                if (this.userInfo.study.form.serum !== null) {
                    this.form.serum = this.userInfo.study.form.serum;
                }
                if (this.userInfo.study.form.plasma !== null) {
                    this.form.plasma = this.userInfo.study.form.plasma;
                }
                if (this.userInfo.study.form.ancillary !== null) {
                    this.form.ancillary = this.userInfo.study.form.ancillary;
                }
                if (this.userInfo.study.form.ductal !== null) {
                    this.form.ductal = this.userInfo.study.form.ductal;
                }
                if (this.userInfo.study.form.frozenPancreaticPcs !== null) {
                    this.form.frozenPancreaticPcs = this.userInfo.study.form.frozenPancreaticPcs;
                }
                if (this.userInfo.study.form.lymphNode !== null) {
                    this.form.lymphNode = this.userInfo.study.form.lymphNode;
                }
                if (this.userInfo.study.form.spleen !== null) {
                    this.form.spleen = this.userInfo.study.form.spleen;
                }
                if (this.userInfo.study.form.duodenum !== null) {
                    this.form.duodenum = this.userInfo.study.form.duodenum;
                }
                // Contact Info
                if (this.userInfo.study.form.title !== null) {
                    this.form.title = this.userInfo.study.form.title;
                }
                if (this.userInfo.study.form.pI_Phone !== null) {
                    this.form.pI_Phone = this.userInfo.study.form.pI_Phone;
                }
                if (this.userInfo.study.form.pI_Phone_Ext !== null) {
                    this.form.pI_Phone_Ext = this.userInfo.study.form.pI_Phone_Ext;
                }
                if (this.userInfo.study.form.pI_Email !== null) {
                    this.form.pI_Email = this.userInfo.study.form.pI_Email;
                }
                if (this.userInfo.study.form.textMsg !== null) {
                    this.form.textMsg = this.userInfo.study.form.textMsg;
                }
                if (this.userInfo.study.form.pI_Cell !== null) {
                    this.form.pI_Cell = this.userInfo.study.form.pI_Cell;
                }
                if (this.userInfo.study.form.provider_ID !== null) {
                    this.form.provider_ID = this.userInfo.study.form.provider_ID;
                }
                if (this.userInfo.study.form.pI_Address_1 !== null) {
                    this.form.pI_Address_1 = this.userInfo.study.form.pI_Address_1;
                }
                if (this.userInfo.study.form.pI_Address_2 !== null) {
                    this.form.pI_Address_2 = this.userInfo.study.form.pI_Address_2;
                }
                if (this.userInfo.study.form.pI_City !== null) {
                    this.form.pI_City = this.userInfo.study.form.pI_City;
                }
                if (this.userInfo.study.form.pI_State !== null) {
                    this.form.pI_State = this.userInfo.study.form.pI_State;
                }
                if (this.userInfo.study.form.pI_State_Oth !== null) {
                    this.form.pI_State_Oth = this.userInfo.study.form.pI_State_Oth;
                }
                if (this.userInfo.study.form.pI_Province !== null) {
                    this.form.pI_Province = this.userInfo.study.form.pI_Province;
                }
                if (this.userInfo.study.form.time_Zone !== null) {
                    this.form.time_Zone = this.userInfo.study.form.time_Zone;
                }
                if (this.userInfo.study.form.timeZoneOther !== null) {
                    this.form.timeZoneOther = this.userInfo.study.form.timeZoneOther;
                }
                if (this.userInfo.study.form.country !== null) {
                    this.form.country = this.userInfo.study.form.country;
                }
                if (this.userInfo.study.form.pI_Zip !== null) {
                    this.form.pI_Zip = this.userInfo.study.form.pI_Zip;
                }
                if (this.userInfo.study.form.hasORCID !== null) {
                    this.form.hasORCID = this.userInfo.study.form.hasORCID;
                }
                if (this.userInfo.study.form.rsnNoORCID !== null) {
                    this.form.rsnNoORCID = this.userInfo.study.form.rsnNoORCID;
                }
                if (this.userInfo.study.form.orcid !== null) {
                    this.form.orcid = this.userInfo.study.form.orcid;
                }
                //  Shipping Info
                if (this.userInfo.study.form.exp_Ship_Acct !== null) {
                    this.form.exp_Ship_Acct = this.userInfo.study.form.exp_Ship_Acct;
                }
                if (this.userInfo.study.form.exp_Ship !== null) {
                    this.form.exp_Ship = this.userInfo.study.form.exp_Ship;
                }
                if (this.userInfo.study.form.exp_Ship_2 !== null) {
                    this.form.exp_Ship_2 = this.userInfo.study.form.exp_Ship_2;
                }
                if (this.userInfo.study.form.exp_Ship_Acct_2 !== null) {
                    this.form.exp_Ship_Acct_2 = this.userInfo.study.form.exp_Ship_Acct_2;
                }
                if (this.userInfo.study.form.shippingNote != null) {
                    this.form.shippingNote = this.userInfo.study.form.shippingNote;
                }
                if (this.userInfo.study.form.sameasMailing != null) {
                    this.form.sameasMailing = this.userInfo.study.form.sameasMailing;
                }
                if (this.userInfo.study.form.wK_Contact != null) {
                    this.form.wK_Contact = this.userInfo.study.form.wK_Contact;
                }
                if (this.userInfo.study.form.wK_Phone != null) {
                    this.form.wK_Phone = this.userInfo.study.form.wK_Phone;
                }
                if (this.userInfo.study.form.wKShipment != null) {
                    this.form.wKShipment = this.userInfo.study.form.wKShipment;
                }
                if (this.userInfo.study.form.wksameasMailing != null) {
                    this.form.wksameasMailing = this.userInfo.study.form.wksameasMailing;
                }
                if (this.userInfo.study.form.ship_Addr_1 !== null) {
                    this.form.ship_Addr_1 = this.userInfo.study.form.ship_Addr_1;
                }
                if (this.userInfo.study.form.ship_Addr_2 !== null) {
                    this.form.ship_Addr_2 = this.userInfo.study.form.ship_Addr_2;
                }
                if (this.userInfo.study.form.ship_City !== null) {
                    this.form.ship_City = this.userInfo.study.form.ship_City;
                }
                if (this.userInfo.study.form.ship_State !== null) {
                    this.form.ship_State = this.userInfo.study.form.ship_State;
                }
                if (this.userInfo.study.form.wK_Ship_Addr_1 !== null) {
                    this.form.wK_Ship_Addr_1 = this.userInfo.study.form.wK_Ship_Addr_1;
                }
                if (this.userInfo.study.form.wK_Ship_Addr_1 !== null) {
                    this.form.wK_Ship_Addr_2 = this.userInfo.study.form.wK_Ship_Addr_2;
                }
                if (this.userInfo.study.form.wK_Ship_City !== null) {
                    this.form.wK_Ship_City = this.userInfo.study.form.wK_Ship_City;
                }
                if (this.userInfo.study.form.wK_Ship_State !== null) {
                    this.form.wK_Ship_State = this.userInfo.study.form.wK_Ship_State;
                }
                if (this.userInfo.study.form.wK_Ship_Zip !== null) {
                    this.form.wK_Ship_Zip = this.userInfo.study.form.wK_Ship_Zip;
                }
                if (this.userInfo.study.form.wK_Ship_Province !== null) {
                    this.form.wK_Ship_Province = this.userInfo.study.form.wK_Ship_Province;
                }
                if (this.userInfo.study.form.wK_Ship_State_Oth !== null) {
                    this.form.wK_Ship_State_Oth = this.userInfo.study.form.wK_Ship_State_Oth;
                }
                //  Research Info
                if (this.userInfo.study.form.study_Title !== null) {
                    this.form.study_Title = this.userInfo.study.form.study_Title;
                }
                if (this.userInfo.study.form.projAbstract !== null) {
                    this.form.projAbstract = this.userInfo.study.form.projAbstract;
                }
                if (this.userInfo.study.form.researchMethods !== null) {
                    this.form.researchMethods = this.userInfo.study.form.researchMethods;
                }
                if (this.userInfo.study.form.isletsReqReason !== null) {
                    this.form.isletsReqReason = this.userInfo.study.form.isletsReqReason;
                }
                if (this.userInfo.study.form.rationaleFrozen !== null) {
                    this.form.rationaleFrozen = this.userInfo.study.form.rationaleFrozen;
                }
                if (this.userInfo.study.form.rationaleHistoSlides !== null) {
                    this.form.rationaleHistoSlides = this.userInfo.study.form.rationaleHistoSlides;
                }
                if (this.userInfo.study.form.rationaleAcinar !== null) {
                    this.form.rationaleAcinar = this.userInfo.study.form.rationaleAcinar;
                }
                if (this.userInfo.study.form.animalResearch !== null) {
                    this.form.animalResearch = this.userInfo.study.form.animalResearch;
                }
                if (this.userInfo.study.form.iacuC_Status !== null) {
                    this.form.iacuC_Status = this.userInfo.study.form.iacuC_Status;
                }
                if (this.userInfo.study.form.iacuC_App_No !== null) {
                    this.form.iacuC_App_No = this.userInfo.study.form.iacuC_App_No;
                }
                if (this.userInfo.study.form.iacuC_App_Dt !== null) {
                    this.form.iacuC_App_Dt = this.userInfo.study.form.iacuC_App_Dt;
                }
                if (this.userInfo.study.form.cellStimulus !== null) {
                    this.form.cellStimulus = this.userInfo.study.form.cellStimulus;
                }
                if (this.userInfo.study.form.cellDeath !== null) {
                    this.form.cellDeath = this.userInfo.study.form.cellDeath;
                }
                if (this.userInfo.study.form.type1Diabetes !== null) {
                    this.form.type1Diabetes = this.userInfo.study.form.type1Diabetes;
                }
                if (this.userInfo.study.form.alphaCells !== null) {
                    this.form.alphaCells = this.userInfo.study.form.alphaCells;
                }
                if (this.userInfo.study.form.geneticsGenomics !== null) {
                    this.form.geneticsGenomics = this.userInfo.study.form.geneticsGenomics;
                }
                if (this.userInfo.study.form.otherArea !== null) {
                    this.form.otherArea = this.userInfo.study.form.otherArea;
                }
                if (this.userInfo.study.form.otherAreaText !== null) {
                    this.form.otherAreaText = this.userInfo.study.form.otherAreaText;
                }
                //   Islet Requirements
                if (this.userInfo.study.form.begin_Dt !== null) {
                    this.form.begin_Dt = this.userInfo.study.form.begin_Dt;
                }
                if (this.userInfo.study.form.comp_Dt !== null) {
                    this.form.comp_Dt = this.userInfo.study.form.comp_Dt;
                }
                if (this.userInfo.study.form.ieQs_Ideal !== null) {
                    this.form.ieQs_Ideal = this.userInfo.study.form.ieQs_Ideal;
                }
                if (this.userInfo.study.form.ieQs_Min !== null) {
                    this.form.ieQs_Min = this.userInfo.study.form.ieQs_Min;
                }
                if (this.userInfo.study.form.purity_Min != null) {
                    this.form.purity_Min = this.userInfo.study.form.purity_Min;
                }
                if (this.userInfo.study.form.purity_Ideal !== null) {
                    this.form.purity_Ideal = this.userInfo.study.form.purity_Ideal;
                }
                if (this.userInfo.study.form.purity_Min !== null) {
                    this.form.purity_Min = this.userInfo.study.form.purity_Min;
                }
                if (this.userInfo.study.form.viability_Min !== null) {
                    this.form.viability_Min = this.userInfo.study.form.viability_Min;
                }
                if (this.userInfo.study.form.viability_Ideal !== null) {
                    this.form.viability_Ideal = this.userInfo.study.form.viability_Ideal;
                }
                if (this.userInfo.study.form.freq_Ideal !== null) {
                    this.form.freq_Ideal = this.userInfo.study.form.freq_Ideal;
                }
                if (this.userInfo.study.form.viability_Min !== null) {
                    this.form.viability_Min = this.userInfo.study.form.viability_Min;
                }
                if (this.userInfo.study.form.freq_Min !== null) {
                    this.form.freq_Min = this.userInfo.study.form.freq_Min;
                }
                if (this.userInfo.study.form.tot_IEQs_Needed !== null) {
                    this.form.tot_IEQs_Needed = this.userInfo.study.form.tot_IEQs_Needed;
                }
                if (this.userInfo.study.form.viability_Min !== null) {
                    this.form.viability_Min = this.userInfo.study.form.viability_Min;
                }
                if (this.userInfo.study.form.cultured_Ideal !== null) {
                    this.form.cultured_Ideal = this.userInfo.study.form.cultured_Ideal;
                }

                if (this.userInfo.study.form.cultured_Min !== null) {
                    this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
                }
                if (this.userInfo.study.form.diabetic_Ideal !== null) {
                    this.form.diabetic_Ideal = this.userInfo.study.form.diabetic_Ideal;
                }
                if (this.userInfo.study.form.diabetic_Min !== null) {
                    this.form.diabetic_Min = this.userInfo.study.form.diabetic_Min;
                }
                if (this.userInfo.study.form.tot_IEQs_Needed !== null) {
                    this.form.tot_IEQs_Needed = this.userInfo.study.form.tot_IEQs_Needed;
                }
                if (this.userInfo.study.form.race !== null) {
                    this.form.race = this.userInfo.study.form.race;
                }
                if (this.userInfo.study.form.aian !== null) {
                    this.form.aian = this.userInfo.study.form.aian;
                }
                if (this.userInfo.study.form.black !== null) {
                    this.form.black = this.userInfo.study.form.black;
                }
                if (this.userInfo.study.form.nhpi !== null) {
                    this.form.nhpi = this.userInfo.study.form.nhpi;
                }
                if (this.userInfo.study.form.asian !== null) {
                    this.form.asian = this.userInfo.study.form.asian;
                }
                if (this.userInfo.study.form.hispanic !== null) {
                    this.form.hispanic = this.userInfo.study.form.hispanic;
                }
                if (this.userInfo.study.form.nhpi !== null) {
                    this.form.nhpi = this.userInfo.study.form.nhpi;
                }
                if (this.userInfo.study.form.white !== null) {
                    this.form.white = this.userInfo.study.form.white;
                }
                if (this.userInfo.study.form.race_Oth !== null) {
                    this.form.race_Oth = this.userInfo.study.form.race_Oth;
                }
                if (this.userInfo.study.form.cultureLen !== null) {
                    this.form.cultureLen = this.userInfo.study.form.cultureLen;
                }
                if (this.userInfo.study.form.cultured_Min !== null) {
                    this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
                }
                if (this.userInfo.study.form.cultureMinDay !== null) {
                    this.form.cultureMinDay = this.userInfo.study.form.cultureMinDay;
                }
                if (this.userInfo.study.form.cultureMinHr !== null) {
                    this.form.cultureMinHr = this.userInfo.study.form.cultureMinHr;
                }
                if (this.userInfo.study.form.cultured_Min !== null) {
                    this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
                }
                if (this.userInfo.study.form.cultureMaxDay !== null) {
                    this.form.cultureMaxDay = this.userInfo.study.form.cultureMaxDay;
                }
                if (this.userInfo.study.form.cultureMaxHr !== null) {
                    this.form.cultureMaxHr = this.userInfo.study.form.cultureMaxHr;
                }
                if (this.userInfo.study.form.bmi !== null) {
                    this.form.bmi = this.userInfo.study.form.bmi;
                }
                if (this.userInfo.study.form.bmiMin1 !== null) {
                    this.form.bmiMin1 = this.userInfo.study.form.bmiMin1;
                }
                if (this.userInfo.study.form.bmiMax1 !== null) {
                    this.form.bmiMax1 = this.userInfo.study.form.bmiMax1;
                }
                if (this.userInfo.study.form.bmiMax2 !== null) {
                    this.form.bmiMax2 = this.userInfo.study.form.bmiMax2;
                }
                if (this.userInfo.study.form.bmiMin2 !== null) {
                    this.form.bmiMin2 = this.userInfo.study.form.bmiMin2;
                }
                if (this.userInfo.study.form.donorAge !== null) {
                    this.userInfo.study.form.donorAge = this.userInfo.study.form.donorAge;
                }
                if (this.userInfo.study.form.donorAgeMin !== null) {
                    this.form.donorAgeMin = this.userInfo.study.form.donorAgeMin;
                }
                if (this.userInfo.study.form.donorAgeMax !== null) {
                    this.form.donorAgeMax = this.userInfo.study.form.donorAgeMax;
                }
                // Funding Info
                if (this.userInfo.study.form.non_Profit !== null) {
                    this.form.non_Profit = this.userInfo.study.form.non_Profit;
                }
                if (this.userInfo.study.form.peer_Rev_Grant !== null) {
                    this.form.peer_Rev_Grant = this.userInfo.study.form.peer_Rev_Grant;
                }
                if (this.userInfo.study.form.fundsAva !== null) {
                    this.form.fundsAva = this.userInfo.study.form.fundsAva;
                }
            }
        }, 1000);
    }
    onFileChange(file: any, type: string) {
        if (file != null) {
            const checkDuplicate = _.findIndex(
                this.userInfo.study.docs,
                (o: any) => o.docName === file.name,
            );

            if (checkDuplicate !== -1) {
                this.$swal({
                    icon: 'error',
                    title: 'Duplicate file detected',
                    text: 'File selection cannot proceed because a file with a similar name has been previously uploaded.',
                });
                if (type === 'agreement') {
                    this.letterAgreementFile = null;
                    this.letterAgreementSelected = false;
                    this.letterAgreementUploaded = false;
                } else if (type === 'biosketch') {
                    this.bioSketchFile = null;
                    this.bioSketchSelected = false;
                    this.bioSketchUploaded = false;
                }
            } else {
                if (type === 'agreement') {
                    this.letterAgreementFile = file;
                    this.letterAgreementSelected = true;
                    this.letterAgreementUploaded = false;
                } else if (type === 'biosketch') {
                    this.bioSketchFile = file;
                    this.bioSketchSelected = true;
                    this.bioSketchUploaded = false;
                }
            }
        }
    }
    async fileUploadAgreement(file: any) {
        try {
            const fields = { id: 1, name: file.name };
            const body = toFormData({ ...fields, file });
            const checkDuplicate = _.findIndex(
                this.userInfo.study.docs,
                (o: any) => o.docName === file.name,
            );
            if (checkDuplicate === -1) {
                const doc = await client.postBody(
                    new StudyMiscDoc({
                        appId: this.userInfo.study.form.appId,
                        docType: 2,
                    }),
                    body,
                );
            }
        } catch {
            /**/
        } finally {
            getUserInfo();
            if (this.userInfo.study.docs.length < 2) {
                this.$emit('has-supporting-documents', false);
            } else {
                this.$emit('has-supporting-documents', true);
            }
        }
    }
    async fileUpload(file: any) {
        try {
            const fields = { id: 1, name: file.name };
            const body = toFormData({ ...fields, file });
            const checkDuplicate = _.findIndex(
                this.userInfo.study.docs,
                (o: any) => o.docName === file.name,
            );
            if (checkDuplicate === -1) {
                const doc = await client.postBody(
                    new StudyMiscDoc({
                        appId: this.userInfo.study.form.appId,
                        docType: 1,
                    }),
                    body,
                );
            }
        } catch {
            /**/
        } finally {
            getUserInfo();
            if (this.userInfo.study.docs.length < 2) {
                this.$emit('has-supporting-documents', false);
            } else {
                this.$emit('has-supporting-documents', true);
            }
        }
    }
    submit() {
        this.$v.$touch();
        this.$emit('update', {
            formData: this.form,
            id: 4,
            file: this.file,
            isValid: !this.$v.$invalid,
        });
    }
    activated() {
        if (
            this.userInfo.data !== undefined &&
            this.userInfo.data.form !== undefined
        ) {
            Object.assign(this.form, this.userInfo.study.form);
        }
    }
    validateForm() {
        return this.$v.$invalid;
    }
    mounted() {
        this.loadToForm();
        this.validateForm();
    }
    loadToForm() {
        bus.$on('userInfo', (payload: any) => {
            Object.assign(this.form, payload.study.form);
        });
    }
    clearFiles() {
        (this.$refs.inputFile as any).reset();
        this.loadToForm();
    }
    get userInfo() {
        return store.userInfo;
    }

    confirmDelete(rec: any) {
        this.$swal({
            title: 'Confirm Delete',
            text:
                'You will not be able to recover this uploaded file. Do you wish to proceed?',
            icon: 'warning',
            showCancelButton: true,
            customClass: {
                confirmButton: 'btn btn-danger m-1',
                cancelButton: 'btn btn-secondary m-1',
            },
            confirmButtonText: 'Yes, delete it!',
            html: false,
            preConfirm: () => {
                return new Promise((resolve: any) => {
                    setTimeout(() => {
                        resolve();
                    }, 50);
                });
            },
        }).then(async (result: any) => {
            if (result.value) {
                const d = await client.delete(
                    new DeleteStudyMiscDoc({
                        docId: rec.docId,
                        appId: rec.appId,
                    }),
                );
                this.userInfo.study.docs = d.docs;
                if (d !== undefined) {
                    this.$swal('Deleted!', 'Uploaded file has been deleted.', 'success');
                    if (this.userInfo.study.docs.length < 2) {
                        this.$emit('has-supporting-documents', false);
                    } else {
                        this.$emit('has-supporting-documents', true);
                    }
                }
            } else if (result.dismiss === 'cancel') {
                this.$swal('Cancelled', 'Delete operation is cancelled.', 'error');
            }
        });
    }
    async confirmAddAgreement(file: any) {
        if (this.letterAgreementFile) {
            await this.fileUploadAgreement(this.letterAgreementFile);
            this.letterAgreementSelected = false;
            this.letterAgreementUploaded = true;
        }
    }

    async confirmAdd(file: any) {
        if (this.bioSketchFile) {
            await this.fileUpload(this.bioSketchFile);
            this.bioSketchSelected = false;
            this.bioSketchUploaded = true;
        }
    }
    resetLetterAgreement() {
        this.letterAgreementFile = null;
        this.letterAgreementSelected = false;
        this.letterAgreementUploaded = false;
    }

    resetBioSketch() {
        this.bioSketchFile = null;
        this.bioSketchSelected = false;
        this.bioSketchUploaded = false;
    }

}
